import { Button, FormControl, Grid, InputLabel, MenuItem, Paper, Select, TextField } from "@material-ui/core";
import {
    createStyles, makeStyles,
    Theme, withStyles
} from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { Edit } from "@material-ui/icons";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import Api from "../../../../helpers/api";
import TicketCommentsModal from "../Library/comment";
import { MessageRounded } from "@material-ui/icons";
import {
    createLibrary, getConfigData, getProjects, getProjectSampleAllData, getProjectSampleList, getSampleProjectData, updateLibrary, uploadMediaFiles
} from "../../store/actions";
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        table: {
            minWidth: 700,
        },
        hoveItem: {
            cursor: "pointer",
        },

        chips: {
            display: "flex",
        },
        input: {
            padding: "1px",
        },
        tableContainer: {
            marginTop: "2rem",
            position: "sticky",
            top: "200px",
        },
        root1: {
            // backgroundColor: "#fa4d83",

        }
    })
);

const StyledTableCell: any = withStyles((theme: Theme) =>
    createStyles({
        head: {
            backgroundColor: "#12145e",
            color: theme.palette.common.white,
            fontSize: "14px",
        },
        body: {
            fontSize: 14,
        },
    })
)(TableCell);

const StyledTableRow: any = withStyles((theme: Theme) =>
    createStyles({
        root: {
            "&:nth-of-type(odd)": {
                backgroundColor: theme.palette.action.hover,
            },
        },
    })
)(TableRow);
interface Props {
    library: any;
    onBoardingActionType: any;
    projects: any;
    getProjects: any;
    getProjectSampleList: any;
    sapmleList: any;
    sampleAllData: any;
    getProjectSampleAllData: any;
    createLibrary: any;
    uploadMediaFiles: any;
    mediaUpload: any;
    fetchsamplepdata: any;
    getSampleProjectData: any;
    updateLibrary: any;
    getConfigData: any;
    FetchConfigData: any;

}
const StopsPlace: React.FC<Props> = ({
    library,
    onBoardingActionType,
    projects,
    getProjects,
    getProjectSampleList,
    sapmleList,
    sampleAllData,
    getProjectSampleAllData,
    createLibrary,
    uploadMediaFiles,
    mediaUpload,
    fetchsamplepdata,
    getSampleProjectData,
    updateLibrary,
    getConfigData,
    FetchConfigData,

}) => {
    const classes = useStyles();
    const history = useHistory();
    const timer = useRef<any>(0);
    const [index, setIndex] = useState<any>("");
    const [displayIndexBool, setDisplayIndexBool] = useState<boolean>(false);
    const [displayIndex, setDisplayIndex] = useState<any>("")
    const [displayDualIndex, setDisplayDualIndex] = useState<any>("")
    const [displayDualIndex1, setDisplayDualIndex1] = useState<any>("")
    const [indexID2, setIndexId2] = useState<any>("");
    const [libraryQC, setLibraryQC] = useState<any>("");
    const [insertSize, setInsertSize] = useState<any>("");
    const [librarySize, setLibrarySize] = useState<any>("");
    const [libType, setLibType] = useState<any>("")
    const [libraryKit, setLibraryKit] = useState<any>("");
    const [page, setPage] = useState(0);
    const [chemistry, setChemistry] = useState<any>("");
    const { id } = useParams<{ id: string }>();
    const [libConcentration, setLibConcentration] = useState<any>("");
    const [libraryStatus, setLibraryStatus] = useState<any>("");
    const [sample, setSample] = useState<string | number>();
    const [displaySample, setDisplaySample] = useState<string>("");
    const [indexType, setIndexType] = useState<any>("");
    const [refreshIt, setRefreshIt] = useState<number>(1);
    const [indexSeq, setIndexSeq] = useState<any>("");
    const [indexSeq2, setIndexSeq2] = useState<any>("")
    const [projectname, setProjectName] = useState<any>("");
    const [freezerNo, setFreezerNo] = useState<any>("");
    const [freezer, setFreezer] = useState<any>("");
    const [project, setProject] = useState<any>("");
    const [isEdit, setIsEdit] = useState<any>(false);
    const [key, setKey] = useState<any>(true);
    const [rack, setRack] = useState<any>("");
    const [box, setBox] = useState<any>("");
    const [libraryId, setLibraryId] = useState<any>("");
    const [wellId, setWellId] = React.useState<any>("");
    const [uploading, setUploading] = useState<boolean>(false);
    const [comment, setComment] = useState<any>("");
    const [openModal, setopenModal] = useState<boolean>(false);
    const [runData, setRunData] = useState<any>("")
    const [fileKey, setFileKey] = useState<string>(Math.random().toString(36));
    const singleIndexes = Object.keys(FetchConfigData?.singleIndex ? FetchConfigData.singleIndex : {})?.map((key: string) => ({ key, value: FetchConfigData?.singleIndex[key] }))
    const dualFirstIndexes = Object.keys(FetchConfigData?.dualFirstIndex ? FetchConfigData?.dualFirstIndex : {}).map((key: string) => ({ key, value: FetchConfigData?.dualFirstIndex[key] }))
    const dualSecondIndexes = Object.keys(FetchConfigData?.dualSecondIndex ? FetchConfigData?.dualSecondIndex : {}).map((key: string) => ({ key, value: FetchConfigData?.dualSecondIndex[key] }))
    // const fileSelectedHandler = async (e: React.ChangeEvent<{ files: any }>, type: any) => {
    //     const formData = new FormData();
    //     formData.append("file", e.target.files[0]);
    //     setUploading(true);
    //     Api.post("/media", formData).then((data: any) => {
    //         setMediaFile({
    //             ...mediaFile,
    //             [type]: data?.path,
    //         })
    //         setUploading(false);
    //     }).catch(() => {
    //         setUploading(false);
    //     });
    // };
    // const [mediaFile, setMediaFile] = useState<any>({
    //     "qcImage": "",
    // }
    // );
    useEffect(() => {
        getProjects();
        getConfigData();
    }, [])

    let [fetchLibraryData, setFetchLibraryData] = useState<any>([]);

    useEffect(() => {
        let storeData: any = [];
        if (fetchsamplepdata && fetchsamplepdata?.results?.length > 0 && project)
            fetchsamplepdata?.results?.filter((data: any) => data?.libraries).map((data: any, index: any) => {
                storeData.push({
                    ...data,
                })
            })

        setFetchLibraryData(storeData);
    }, [fetchsamplepdata, project])

    useEffect(() => {
        if (project !== "") {
            getProjectSampleAllData(`?qcCompleted=true&qcStatus=Pass&project=${project}`);
        }

    }, [project])

    useEffect(() => {
        if (project !== "") {
            getSampleProjectData(`?project=${project}`);

        }

    }, [project])
    const handleAddSequence = async (e: any) => {
        e.preventDefault();
        // const filterPath = mediaFile
        const librarydata = {
            kit: libraryKit,
            status: libraryStatus,
            freezerName: freezer,
            freezerNo: freezerNo,
            concentration: libConcentration,
            library_qc_status: libraryQC,
            type: libType,
            chemistry: chemistry,
            size: insertSize,
            boxId: box,
            wellId: wellId,
            rackNo: rack,
            librarySize: librarySize,
            indexType: indexType,
            firstIndex: index,
            comment: comment,
            // secondIndex: indexID2,
            secondIndex: indexSeq,
            // secondSeq: indexSeq2,

        }
        if (isEdit === true) {
            await updateLibrary(sample, { ...librarydata, _id: libraryId });
        } else if (sample && librarydata) {
            await createLibrary(sample, librarydata);
        }
        getSampleProjectData(`?project=${project}`);
        setIsEdit(false);
        setSample("");
        setDisplaySample("");
        setLibraryKit("");
        setLibraryStatus("");
        setFreezer("");
        setFreezerNo("");
        setLibConcentration("");
        setIndexType("");
        setIndex("");
        setIndexId2("");
        setIndexSeq("");
        setIndexSeq2("");
        setLibType("");
        setInsertSize("");
        setChemistry("");
        setBox("");
        setWellId("");
        setRack("");
        setLibrarySize("");
        setDisplayIndexBool(false);
        // setMediaFile("");
        setComment("");
        setFileKey(Math.random().toString(36));

    };
    const handleEdit = ({ library: val, sample }: any) => {
        setIsEdit(true);
        setLibraryId(val?._id)
        setSample(sample?._id);
        setDisplaySample(sample?.name);
        setLibraryKit(val?.kit);
        setLibraryStatus(val?.status);
        setFreezer(val?.freezerName);
        setFreezerNo(val?.freezerNo);
        setLibConcentration(val?.concentration);
        setIndexType(val?.indexType);
        setIndex(val?.firstIndex);
        setDisplayIndex(val?.firstIndex);
        setDisplayIndexBool(false);
        setIndexId2(val?.firstSeq);
        setDisplayDualIndex1(val?.firstSeq);
        setIndexSeq(val?.secondIndex);
        setDisplayDualIndex(val?.secondIndex);
        setIndexSeq2(val?.secondSeq);
        setLibType(val?.type);
        setInsertSize(val?.size);
        setChemistry(val?.chemistry);
        setBox(val?.boxId);
        setWellId(val?.wellId);
        setRack(val?.rackNo);
        setLibrarySize(val?.librarySize);
        setComment(val?.comment);
        // setMediaFile(
        //     {
        //         "qcImage": (val?.qcReport),
        //     }
        // )
        setKey(!key);
    };
    const handleClick = (data: any) => {
        setopenModal(true);
        setRunData(data);
    };
    const handleIndexType = (e: any) => {
        setIndexType(e.target.value);
        setRefreshIt(refreshIt === 1 ? 2 : 1);
        setIndex("");
        setIndexId2("");
        setIndexSeq("");
        setIndexSeq2("");
    }

    return (
        <Grid container spacing={2}>
            <form onSubmit={handleAddSequence} style={{ width: "100%" }}>
                <Paper style={{ margin: "70px auto", width: "100%", marginTop: 10 }}>
                    <h2 style={{ fontWeight: "bold", paddingTop: "20px", paddingBottom: "10px", textAlign: "center" }}>Library Details</h2>
                    <Grid container spacing={2} style={{ marginLeft: 1 }}>
                        <Grid item xs={12} sm={4} md={2} >
                            <Autocomplete
                                id="Project"
                                onChange={(event, newValue) => {
                                    if (newValue) {
                                        setProject(newValue?._id);
                                    } else {
                                        setProject("")
                                    }
                                }}
                                options={projects?.results || []}
                                blurOnSelect
                                getOptionLabel={(option: any) => {
                                    return (
                                        (option?.projectId) +
                                        " " +
                                        (option?.institute?.name || "") +
                                        " " +
                                        (option?.scientist?.name || "") +
                                        "," +
                                        (option?.dealer?.firmName || "")
                                    );
                                }}
                                onInputChange={(event, newInputValue) => {
                                    let data = newInputValue.split(" ");
                                    clearTimeout(timer.current);
                                    timer.current = setTimeout(() => {
                                        if (data.length > 0) {
                                            getProjects(`?projectId=${data[0]}`);
                                        }
                                    }, 1000);
                                    setProjectName(newInputValue);
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        className="input"
                                        label="Project"
                                        placeholder="Search Id/Clien/Dealer Name"
                                        variant="outlined"
                                        fullWidth
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={2}>
                            <Autocomplete
                                id="Project"
                                onChange={(event, newValue) => {
                                    setSample(newValue?._id);

                                }}
                                options={sampleAllData?.results || []}
                                blurOnSelect
                                disableCloseOnSelect
                                aria-required
                                getOptionLabel={(option: any) => `${option?.name}`}
                                inputValue={displaySample}
                                onInputChange={(event, newInputValue) => {
                                    setDisplaySample(newInputValue)
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        className="input"
                                        label="Sample Names"
                                        placeholder="Select Sample Name"
                                        variant="outlined"
                                        required
                                        fullWidth
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={2}>
                            <FormControl style={{ width: "100%" }} className="input">
                                <InputLabel>Lib Type*</InputLabel>
                                <Select
                                    label="Lib Type"
                                    variant="outlined"
                                    className="input"
                                    fullWidth
                                    required
                                    value={libType || "none"}
                                    style={{ width: "100%", height: "40px" }}
                                    onChange={(e) => setLibType(e.target.value)}
                                >
                                    <MenuItem value="none" disabled><em>Select Lib Type</em></MenuItem>
                                    <MenuItem value="Short Read">Short Read </MenuItem>
                                    <MenuItem value="Long Read">Long Read</MenuItem>
                                    <MenuItem value="CLR">CLR</MenuItem>
                                    <MenuItem value="HiFi">HiFi</MenuItem>
                                    <MenuItem value="HiC">HiC</MenuItem>
                                    <MenuItem value="SE">SE</MenuItem>
                                    <MenuItem value="Others">Others</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4} md={2}>
                            <TextField
                                label="Library Kit"
                                variant="outlined"
                                className="input"
                                placeholder="Enter Library Kit Name"
                                fullWidth
                                required
                                value={libraryKit}
                                onChange={(e) => setLibraryKit(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={2}>
                            <FormControl style={{ width: "100%" }} className="input">
                                <InputLabel>Index Type*</InputLabel>
                                <Select
                                    label="Index Type"
                                    variant="outlined"
                                    className="input"
                                    fullWidth
                                    required
                                    value={indexType || "none"}
                                    style={{ width: "100%", height: "40px" }}
                                    onChange={handleIndexType}
                                >
                                    <MenuItem value="none" disabled><em>Select Index Type</em></MenuItem>
                                    <MenuItem value="Single Index">Single Index</MenuItem>
                                    <MenuItem value="Dual Index">Dual Index</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        {indexType === "Single Index" ?
                            <>
                                <Grid item xs={12} sm={4} md={2}>
                                    <Autocomplete
                                        id="Index"
                                        key={isEdit}
                                        onChange={(event, newValue) => {
                                            setIndex(newValue?.key);
                                            setIndexId2(newValue?.value)
                                        }}
                                        options={singleIndexes}
                                        blurOnSelect
                                        disableCloseOnSelect
                                        getOptionLabel={(option: any) => `${option?.key}`}
                                        inputValue={displayIndex}
                                        onInputChange={(event, newInputValue) => {
                                            if (newInputValue.length || displayIndexBool) {
                                                setDisplayIndex(newInputValue);
                                            } else {
                                                setDisplayIndexBool(true);

                                            }
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                className="input"
                                                label="Index ID"
                                                placeholder="Select Index ID"
                                                variant="outlined"
                                                fullWidth
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4} md={2}>
                                    <Autocomplete
                                        id="Index"
                                        key={refreshIt}
                                        options={singleIndexes}
                                        blurOnSelect
                                        disableCloseOnSelect
                                        getOptionLabel={(option: any) => `${option?.value}`}
                                        inputValue={indexID2}
                                        disabled
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                className="input"
                                                label="Index Seq"
                                                placeholder="Select Index Seq"
                                                variant="outlined"
                                                fullWidth
                                            />
                                        )}
                                    />
                                </Grid>
                            </>
                            : ""}
                        {indexType === "Dual Index" ?
                            <>
                                <Grid item xs={12} sm={4} md={2}>
                                    <Autocomplete
                                        key={isEdit}
                                        id="dualId"
                                        onChange={(event, newValue) => {
                                            setIndex(newValue?.key);
                                            setIndexId2(newValue?.value)
                                        }}
                                        options={dualFirstIndexes || []}
                                        blurOnSelect
                                        disableCloseOnSelect
                                        getOptionLabel={(option: any) => `${option?.key}`}
                                        inputValue={displayDualIndex}
                                        onInputChange={(event, newInputValue) => {
                                            if (newInputValue.length || displayIndexBool) {
                                                setDisplayDualIndex(newInputValue);
                                            } else {
                                                setDisplayIndexBool(true);

                                            }
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                className="input"
                                                label="Dual Index First ID"
                                                placeholder="Select Dual First Index ID"
                                                variant="outlined"
                                                fullWidth
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4} md={2}>
                                    <Autocomplete
                                        id="dualSeq"
                                        options={dualFirstIndexes || []}
                                        blurOnSelect
                                        disableCloseOnSelect
                                        getOptionLabel={(option: any) => `${option?.value}`}
                                        inputValue={indexID2}
                                        disabled
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                className="input"
                                                label="Dual Index First Seq"
                                                placeholder="Select Dual First Index Seq"
                                                variant="outlined"
                                                fullWidth
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4} md={2}>
                                    <Autocomplete
                                        key={isEdit}
                                        id="dualSecondSeq"
                                        onChange={(event, newValue) => {
                                            setIndexSeq(newValue?.key);
                                            setIndexSeq2(newValue?.value);
                                        }}
                                        options={dualSecondIndexes || []}
                                        blurOnSelect
                                        disableCloseOnSelect
                                        getOptionLabel={(option: any) => `${option?.key}`}
                                        inputValue={displayDualIndex1}
                                        onInputChange={(event, newInputValue) => {
                                            if (newInputValue.length || displayIndexBool) {
                                                setDisplayDualIndex1(newInputValue);
                                            } else {
                                                setDisplayIndexBool(true);

                                            }
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                className="input"
                                                label="Dual Index Second ID"
                                                placeholder="Select Dual Second Index ID"
                                                variant="outlined"
                                                fullWidth
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4} md={2}>
                                    <Autocomplete
                                        id="dualSecondSeq"
                                        options={dualSecondIndexes || []}
                                        blurOnSelect
                                        disableCloseOnSelect
                                        getOptionLabel={(option: any) => `${option?.value}`}
                                        inputValue={indexSeq2}
                                        disabled
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                className="input"
                                                label="Dual Index Second Seq"
                                                placeholder="Select Dual Second Index Seq"
                                                variant="outlined"
                                                fullWidth
                                            />
                                        )}
                                    />
                                </Grid>
                            </>
                            : ""}
                        <Grid item xs={12} sm={4} md={2}>
                            <FormControl style={{ width: "100%" }} className="input">
                                <InputLabel>Insert Size*</InputLabel>
                                <Select
                                    label="Library Size"
                                    variant="outlined"
                                    className="input"
                                    fullWidth
                                    value={insertSize || "none"}
                                    style={{ width: "100%", height: "40px" }}
                                    onChange={(e) => setInsertSize(e.target.value)}
                                >
                                    <MenuItem value="none" disabled><em>Select Insert Size</em></MenuItem>
                                    <MenuItem value="250">250</MenuItem>
                                    <MenuItem value="300">300</MenuItem>
                                    <MenuItem value="450">450</MenuItem>
                                    <MenuItem value="550">550</MenuItem>
                                    <MenuItem value="800">800</MenuItem>
                                    <MenuItem value="SE">SE</MenuItem>
                                    <MenuItem value="1kb">1kb</MenuItem>
                                    <MenuItem value="5kb">5kb</MenuItem>
                                    <MenuItem value="7kb">7kb</MenuItem>
                                    <MenuItem value="10kb">10kb</MenuItem>
                                    <MenuItem value="1-2kb (PB)">1-2kb (PB)</MenuItem>
                                    <MenuItem value="2-3kb (PB)">2-3kb  (PB)</MenuItem>
                                    <MenuItem value="3-6kb (PB)">3-6kb  (PB)</MenuItem>
                                    <MenuItem value="5-10kb (PB)">5-10kb  (PB)</MenuItem>
                                    <MenuItem value="10kb CLR">10kb CLR</MenuItem>
                                    <MenuItem value="20kb CLR">20kb CLR</MenuItem>
                                    <MenuItem value="Others">Others</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4} md={2}>
                            <TextField
                                label="Library Size"
                                variant="outlined"
                                className="input"
                                placeholder="Enter Library Size"
                                fullWidth
                                value={librarySize}
                                onChange={(e) => setLibrarySize(e.target.value.replace(/\s/g, ''))}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={2} >
                            <FormControl style={{ width: "100%" }} className="input">
                                <InputLabel>Freezer Name*</InputLabel>
                                <Select
                                    label="Freezer Name"
                                    variant="outlined"
                                    className="input"
                                    fullWidth
                                    required
                                    value={freezer || "none"}
                                    style={{ width: "100%", height: "40px" }}
                                    onChange={(e) => setFreezer(e.target.value)}
                                >
                                    <MenuItem value="none" disabled><em>Select Freezer Name</em></MenuItem>
                                    <MenuItem value="Freezer 4°C">Freezer 4°C</MenuItem>
                                    <MenuItem value="Freezer -20°C">Freezer -20°C</MenuItem>
                                    <MenuItem value="Deep Freezer -80°C">Deep Freezer -80°C </MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4} md={2} >
                            <FormControl style={{ width: "100%" }} className="input">
                                <InputLabel>Freezer No*</InputLabel>
                                <Select
                                    label="Freezer No"
                                    variant="outlined"
                                    className="input"
                                    fullWidth
                                    value={freezerNo || "none"}
                                    style={{ width: "100%", height: "40px" }}
                                    onChange={(e) => setFreezerNo(e.target.value)}
                                >
                                    <MenuItem value="none" disabled><em>Select Freezer No</em></MenuItem>
                                    <MenuItem value="1">Freezer 1</MenuItem>
                                    <MenuItem value="2">Freezer 2</MenuItem>
                                    <MenuItem value="3">Freezer 3</MenuItem>
                                    <MenuItem value="4">Freezer 4</MenuItem>
                                    <MenuItem value="5">Freezer 5</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4} md={2}>
                            <TextField
                                label="Rack No"
                                variant="outlined"
                                className="input"
                                type="number"
                                placeholder="Enter Rack No"
                                required
                                fullWidth
                                value={rack}
                                onChange={(e) => setRack(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={2}>
                            <TextField
                                label="Box No"
                                variant="outlined"
                                className="input"
                                type="number"
                                placeholder="Enter Box No"
                                required
                                fullWidth
                                value={box}
                                onChange={(e) => setBox(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={2}>
                            <TextField
                                label="Well No"
                                variant="outlined"
                                className="input"
                                type="number"
                                required
                                fullWidth
                                placeholder="Enter Well No"
                                value={wellId}
                                onChange={(e) => setWellId(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={2}>
                            <FormControl style={{ width: "100%" }} className="input">
                                <InputLabel>Chemistry</InputLabel>
                                <Select
                                    label="Chemistry"
                                    variant="outlined"
                                    className="input"
                                    fullWidth
                                    value={chemistry || "none"}
                                    style={{ width: "100%", height: "40px" }}
                                    onChange={(e) => setChemistry(e.target.value)}
                                >
                                    <MenuItem value="none"><em>Select</em></MenuItem>
                                    <MenuItem value="Novaseq">Novaseq</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4} md={2}>
                            <FormControl style={{ width: "100%" }} className="input">
                                <InputLabel>Library Status*</InputLabel>
                                <Select
                                    label="Library QC Status"
                                    variant="outlined"
                                    className="input"
                                    fullWidth
                                    value={libraryStatus || "none"}
                                    style={{ width: "100%", height: "40px" }}
                                    onChange={(e) => setLibraryStatus(e.target.value)}
                                >
                                    <MenuItem value="none" disabled><em>Select Library Status</em></MenuItem>
                                    <MenuItem value="Pass">Pass </MenuItem>
                                    <MenuItem value="Fail"> Fail </MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4} md={2}>
                            <TextField
                                label="Concentration(ng/ul)"
                                variant="outlined"
                                className="input"
                                fullWidth
                                placeholder="Enter Library Concentration"
                                value={libConcentration}
                                onChange={(e) => setLibConcentration(e.target.value.replace(/\s/g, ''))}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={2}>
                            <TextField
                                id="filled-number"
                                className="input"
                                label="Comment"
                                fullWidth
                                value={comment}
                                placeholder="type Comments"
                                variant="outlined"
                                onChange={(e) => setComment(e.target.value)}
                            />
                        </Grid>
                        {/* <Grid item xs={12} sm={4} md={3} style={{ marginTop: "-15px" }}>
                            <sup
                                key={isEdit}
                                style={{
                                    fontSize: "11px",
                                    marginLeft: "15px",
                                    marginTop: "15px",
                                    background: "#fff",
                                    color: "rgba(0, 0, 0, 0.54)",
                                    letterSpacing: "0.00938em",
                                }}
                            >
                                Library QC Image
                            </sup>
                            <input
                                className={classes.input}
                                style={{
                                    width: "100%",
                                    height: "46px",
                                    marginTop: "-15px",
                                    padding: "11.5px 14px",
                                    border: "1px solid rgba(0, 0, 0, 0.23)",
                                    borderRadius: "5px",
                                }}
                                type="file"
                                name="file"
                                id="file"
                                multiple
                                key={`${fileKey}qcimage`}
                                onChange={(e: any) => fileSelectedHandler(e, "qcImage")}
                            />
                        </Grid> */}
                        <Grid item xs={12} sm={4} md={2}>
                            <Button
                                color="primary"
                                variant="contained"
                                type="submit"
                                style={{ width: 200, height: 46, marginTop: -5 }}
                                disabled={uploading}
                            >
                                {isEdit ? "Update" : "Add"}
                            </Button>
                        </Grid>
                    </Grid>
                    <div className="data-table"
                        style={{ width: "100%", marginTop: "1rem" }}>
                        <TableContainer className={classes.tableContainer} component={Paper} style={{ maxHeight: "550px", maxWidth: "92vw" }}>
                            <Table stickyHeader aria-label="simple table">
                                <TableHead>
                                    <StyledTableRow>
                                        <StyledTableCell align="center">Sample Name</StyledTableCell>
                                        <StyledTableCell align="center">Lib Type</StyledTableCell>
                                        <StyledTableCell align="center">Lib ID</StyledTableCell>
                                        <StyledTableCell align="center">Library Kit</StyledTableCell>
                                        <StyledTableCell align="center">Index Type</StyledTableCell>
                                        <StyledTableCell align="center">Index ID</StyledTableCell>
                                        <StyledTableCell align="center">Index Seq</StyledTableCell>
                                        <StyledTableCell align="center">Index ID 2</StyledTableCell>
                                        <StyledTableCell align="center">Index Seq 2</StyledTableCell>
                                        <StyledTableCell align="center">Insert Size</StyledTableCell>
                                        <StyledTableCell align="center">Freezer name</StyledTableCell>
                                        <StyledTableCell align="center">Library QC Status</StyledTableCell>
                                        <StyledTableCell align="center">Chemistry</StyledTableCell>
                                        <StyledTableCell align="center">Concentration</StyledTableCell>
                                        {/* <StyledTableCell align="center">Library Qc Report</StyledTableCell> */}
                                        <StyledTableCell align="center">Comment</StyledTableCell>
                                        <StyledTableCell align="center">Edit</StyledTableCell>
                                    </StyledTableRow>
                                </TableHead>
                                <TableBody>
                                    {fetchLibraryData?.flatMap((sample: any, index: any) => {
                                        return sample?.libraries?.length > 0 && sample?.libraries?.map((library: any) =>
                                            <StyledTableRow key={index}>
                                                <StyledTableCell align="center">{sample?.name}</StyledTableCell>
                                                <StyledTableCell align="center">{library?.type}</StyledTableCell>
                                                <StyledTableCell align="center">{library?.libraryId}</StyledTableCell>
                                                <StyledTableCell align="center">{library?.kit}</StyledTableCell>
                                                <StyledTableCell align="center">{library?.indexType}</StyledTableCell>
                                                <StyledTableCell align="center">{library?.firstIndex}</StyledTableCell>
                                                <StyledTableCell align="center">{library?.firstSeq}</StyledTableCell>
                                                <StyledTableCell align="center">{library?.secondIndex}</StyledTableCell>
                                                <StyledTableCell align="center">{library?.secondSeq}</StyledTableCell>
                                                <StyledTableCell align="center">{library?.size}</StyledTableCell>
                                                <StyledTableCell align="center">{library?.freezerName}</StyledTableCell>
                                                <StyledTableCell align="center">{library?.status}</StyledTableCell>
                                                <StyledTableCell align="center">{library?.chemistry}</StyledTableCell>
                                                <StyledTableCell align="center">{library?.concentration}</StyledTableCell>
                                                {/* <StyledTableCell align="center">
                                                    {library?.qcReport !== "" ?
                                                        <a href={library?.qcReport} target="_blank" rel="noopener noreferrer">View</a>
                                                        : ""}
                                                </StyledTableCell> */}
                                                <StyledTableCell align="center">
                                                    {library?.comment === "" ? "" :
                                                        <div>
                                                            <MessageRounded
                                                                onClick={() => handleClick(library)}
                                                            />
                                                        </div>
                                                    }
                                                </StyledTableCell>
                                                <StyledTableCell align="center">
                                                    <Button
                                                        color="primary"
                                                        variant="contained"
                                                    >
                                                        <Edit onClick={() => handleEdit({ library, sample })} />
                                                    </Button>
                                                </StyledTableCell>

                                            </StyledTableRow>
                                        )
                                    })}
                                </TableBody>
                            </Table>

                        </TableContainer>
                        <TicketCommentsModal
                            openModal={openModal}
                            setopenModal={setopenModal}
                            rundata={runData}
                        />
                    </div>
                </Paper>
            </form>
        </Grid >

    );
};
const mapStateToProps = (state: any) => ({
    projects: state.GenomicsLabReducer.projects,
    sapmleList: state.GenomicsLabReducer.sapmleList,
    sampleAllData: state.GenomicsLabReducer.sampleAllData,
    mediaUpload: state.GenomicsLabReducer.mediaUpload,
    fetchsamplepdata: state.GenomicsLabReducer.fetchsamplepdata,
    FetchConfigData: state.GenomicsLabReducer.FetchConfigData,


});
export default connect(mapStateToProps, {
    getProjects,
    getProjectSampleList,
    getProjectSampleAllData,
    createLibrary,
    uploadMediaFiles,
    getSampleProjectData,
    updateLibrary,
    getConfigData,

})(StopsPlace);
